/* Copyright (c) 2020-2024 Nordcloud Oy or its affiliates. All Rights Reserved. */

import dayjs from "dayjs";
import { Else, If, Then } from "react-if";
import styled from "styled-components";
import { Box, FlexContainer, SVGIcon, Text, theme } from "@nordcloud/gnui";
import { dateFormat } from "~/constants";
import { isNil } from "~/tools";

type Props = {
  lastScanEndDate?: string | null;
};

export function LastScanStatus({ lastScanEndDate }: Props) {
  return (
    <StyledBox boxStyle="lightGrey">
      <Text mb={theme.spacing.spacing03} weight="medium">
        Last Scan
      </Text>
      <If condition={isNil(lastScanEndDate)}>
        <Then>
          <FlexContainer>
            <SVGIcon name="cloudQuestionMark" color="warning" size="md" />
            <Text ml={theme.spacing.spacing02} tag="span">
              Unknown
            </Text>
          </FlexContainer>
        </Then>
        <Else>
          <FlexContainer>
            <SVGIcon name="statusSuccess" color="success" size="md" />
            <Text ml={theme.spacing.spacing02} tag="span">
              Successful
            </Text>
          </FlexContainer>
          <Text
            tag="div"
            size="sm"
            color={theme.color.text.text02}
            paddingLeft={theme.spacing.spacing07}
          >
            {dayjs(lastScanEndDate).format(dateFormat.dayMonthYearHourMinute)}
          </Text>
        </Else>
      </If>
    </StyledBox>
  );
}

const StyledBox = styled(Box)`
  flex: 1;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  margin-top: -0.0625rem;
`;
